import { render, staticRenderFns } from "./PortfolioStructureItem.vue?vue&type=template&id=36fe2298&"
import script from "./PortfolioStructureItem.vue?vue&type=script&lang=js&"
export * from "./PortfolioStructureItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports